module.exports = __webpack_public_path__ + "static/media/Alien Avenger.a6088340.jpg";